import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, resolveComponent as _resolveComponent, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2f69fd3c"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "D-Flex",
  style: {"position":"absolute","left":"0.5cm","top":"4cm","direction":"ltr"}
}
const _hoisted_2 = { class: "P_25em" }
const _hoisted_3 = { class: "P_25em" }
const _hoisted_4 = { class: "M-Auto" }
const _hoisted_5 = { class: "CoookiesPrintPlaceAdjuster" }
const _hoisted_6 = { class: "W-100 D-Flex PrintHeader" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "M-Auto",
  style: {"margin":"0px 5px"}
}, "Print", -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  id: "PrintingPlace",
  class: "CookiesPrintPage"
}, null, -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "الادارة: منطقة الرقيم - تلفون 4161262 - 9626461252 - فاكس: 4165391 - ص.ب 183742 عمان 11118 الاردن", -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Head Office Tel: +962 6 4161252 - 4616262 - Fax: 4165391 - P.O.BOX: 183742 Amman 11118 Jordan", -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Email: nader@saedyGroup.com", -1))
const _hoisted_12 = [
  _hoisted_9,
  _hoisted_10,
  _hoisted_11
]
const _hoisted_13 = {
  key: 1,
  class: "D-Flex",
  style: {"position":"absolute","width":"100%","left":"0","top":"0.5cm","direction":"ltr"}
}
const _hoisted_14 = {
  class: "P_25em F1_25em M-Auto",
  style: {"text-align":"right","margin-right":"0.5cm"}
}
const _hoisted_15 = ["innerHTML"]
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_17 = {
  key: 0,
  class: "F_75em",
  style: {"margin-top":"0.5em"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CookiesIcon = _resolveComponent("CookiesIcon")!

  return (_openBlock(), _createElementBlock("div", {
    Ref: "PrintHolder",
    class: "CoookiesPrintBG P-Rel",
    style: _normalizeStyle({direction: _ctx.$store.getters.Direction})
  }, [
    (_ctx.PrintingOptions.Header)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("span", _hoisted_2, _toDisplayString(_ctx.JsonDateParser(new Date())), 1),
          _createTextVNode("-"),
          _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.JsonTimeParser(new Date())), 1)
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", {
      class: "D-Flex Inset0 F2_5em noprint BG1Fixed",
      style: _normalizeStyle([{"position":"fixed","z-index":"9999999"}, {background: _ctx.Theme.BG1Fixed}])
    }, [
      _createElementVNode("span", {
        style: _normalizeStyle([{color: _ctx.Theme.color3}, {"display":"flex","flex-direction":"column"}]),
        class: "M-Auto"
      }, [
        _createElementVNode("span", null, _toDisplayString(_ctx.Translate('Printing...')), 1),
        _createElementVNode("button", {
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.ClosePrint && _ctx.ClosePrint(...args))),
          class: "PrintButtons D-Flex",
          style: {"background":"var(--colorr1)"}
        }, [
          _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.Translate('Close')), 1)
        ])
      ], 4)
    ], 4),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("button", {
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.Print())),
          class: "PrintButtons D-Flex"
        }, [
          _hoisted_7,
          _createVNode(_component_CookiesIcon, {
            style: {"width":"1.5em","height":"1.5em"},
            ID: 'Printer'
          })
        ]),
        _createElementVNode("button", {
          onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$store.state.Printing = '')),
          class: "PrintButtons D-Flex",
          style: {"background":"var(--colorr1)"}
        }, "Close")
      ]),
      _hoisted_8,
      _createElementVNode("div", {
        class: "W-100",
        style: _normalizeStyle([{"border-top":"1px solid","padding-top":"0.3cm","margin-top":"3cm","margin-bottom":"0","bottom":"0","position":"fixed"}, `border-color: ${_ctx.Theme.UserColors.Dimmed};`])
      }, _hoisted_12, 4)
    ]),
    (_ctx.PrintingOptions.Header)
      ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
          _createElementVNode("div", {
            class: "P_25em M-Auto",
            style: _normalizeStyle([{"margin-left":"0.5cm","width":"4cm","height":"2.75cm","background-size":"contain","background-repeat":"no-repeat","background-position":"center"}, 'background-image: url(' + _ctx.$store.getters.DynamicConfig.Logo + ');'])
          }, null, 4),
          _createElementVNode("div", {
            class: "M-Auto",
            style: _normalizeStyle([{"margin-left":"0.5cm","flex":"1","height":"2.75cm","background-size":"contain","background-repeat":"no-repeat","background-position":"center left"}, _ctx.$store.state.BranchManagment?.CurrentBranch?.IsCustomIdentity ? '' : 'background-image: url(' + require('@/assets/icons/GoldenCustoms.svg') + ');'])
          }, null, 4),
          _createElementVNode("div", _hoisted_14, [
            _createElementVNode("span", {
              style: {"text-align":"justify !important"},
              innerHTML: _ctx.$store.getters.DynamicConfig.Name.replaceAll('\n', '<br>')
            }, null, 8, _hoisted_15),
            _hoisted_16,
            (_ctx.HaveSystem('Branches'))
              ? (_openBlock(), _createElementBlock("span", _hoisted_17, _toDisplayString(_ctx.$store.state.BranchManagment.CurrentBranch?.Name), 1))
              : _createCommentVNode("", true)
          ])
        ]))
      : _createCommentVNode("", true)
  ], 4))
}